// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles and CSS reset */
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

:root {
	/* Color palette */
	--primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	--primary-color: #667eea;
	--primary-hover: #5a67d8;
	--secondary-color: #4a5568;
	--success-color: #48bb78;
	--success-hover: #38a169;
	--warning-color: #f6e05e;
	--danger-color: #dc3545;

	/* Background colors */
	--bg-primary: rgba(255, 255, 255, 0.95);
	--bg-secondary: rgba(255, 255, 255, 0.8);
	--bg-card: rgba(255, 255, 255, 0.8);
	--bg-overlay: rgba(0, 0, 0, 0.7);

	/* Text colors */
	--text-primary: #333;
	--text-secondary: #4a5568;
	--text-muted: #718096;
	--text-light: #a0aec0;

	/* Border colors */
	--border-light: #e2e8f0;
	--border-focus: #667eea;

	/* Spacing */
	--spacing-xs: 0.25rem;
	--spacing-sm: 0.5rem;
	--spacing-md: 1rem;
	--spacing-lg: 1.5rem;
	--spacing-xl: 2rem;
	--spacing-xxl: 3rem;

	/* Border radius */
	--radius-sm: 4px;
	--radius-md: 8px;
	--radius-lg: 12px;
	--radius-xl: 16px;
	--radius-pill: 20px;

	/* Shadows */
	--shadow-sm: 0 2px 20px rgba(0, 0, 0, 0.1);
	--shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
	--shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.1);
	--shadow-focus: 0 0 0 3px rgba(102, 126, 234, 0.1);

	/* Transitions */
	--transition-fast: all 0.2s ease;
	--transition-slow: all 0.3s ease;
}

body {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	background: var(--primary-gradient);
	min-height: 100vh;
	color: var(--text-primary);
	line-height: 1.6;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	/* height: 100vh; */
	/* display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box; */
}

.app {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.main-content {
	flex: 1;
	padding: var(--spacing-xl);
	display: flex;
	flex-direction: column;
}

.screen {
	background: var(--bg-primary);
	backdrop-filter: blur(10px);
	border-radius: var(--radius-xl);
	padding: var(--spacing-xl);
	box-shadow: var(--shadow-lg);
	flex: 1;
	display: flex;
	flex-direction: column;
	animation: slideIn 0.3s ease-out;
}

.screen.home {
	width: 100%;
	height: 100%;
	gap: 2rem;
	box-sizing: border-box;

	display: grid;
	grid-template-areas:
		"header  header  header  header"
		"btn-reg btn-tkt status activity"
		"scale   scale   cam2   cam3"
		"cam1    cam1    cam2   cam3"
		"cam1    cam1    cam4   cam5"
		"cam1    cam1    cam4   cam5";
	grid-template-rows: 120px 220px 150px 1fr 1fr 1fr;
	grid-template-columns: repeat(4, 1fr);
}

.ticket-screen-capture {
	width: 100%;
	height: 100%;
	gap: 2rem;
	box-sizing: border-box;

	display: grid;
	grid-template-areas:
		"scale   scale   cam2   cam3"
		"cam1    cam1    cam2   cam3"
		"cam1    cam1    cam4   cam5"
		"cam1    cam1    cam4   cam5"
		"guide	 guide	 button	button";
	grid-template-rows: 150px 1fr 1fr 1fr;
	grid-template-columns: repeat(4, 1fr);
}

.register-screen {
	width: 100%;
	height: 100%;
	gap: 2rem;
	box-sizing: border-box;

	display: grid;
	grid-template-areas:
		"scale   scale   cam2   cam3"
		"cam1    cam1    cam2   cam3"
		"cam1    cam1    cam4   cam5"
		"cam1    cam1    cam4   cam5"
		"guide	 guide	 button	button";
	grid-template-rows: 150px 1fr 1fr 1fr;
	grid-template-columns: repeat(4, 1fr);
}

/* @media (max-width: 1800px) {
	.screen {
		grid-template-areas:
		"header  header  header  header"
		"btn-reg btn-tkt status activity"
		"scale   scale   cam2   cam2"
		"cam1    cam1    cam2   cam3"
		"cam1    cam1    cam4   cam5";
		grid-template-rows: 120px 220px 150px auto auto;
	}
} */

@media (max-width: 1200px) {
	.screen.home {
		grid-template-areas:
		"header  header"
		"btn-reg btn-tkt"
		"status activity"
		"scale   scale"
		"cam1    cam1"
		"cam2    cam3"
		"cam4    cam5";
		grid-template-rows: 120px 220px 180px 140px auto auto auto;
		grid-template-columns: repeat(2, 1fr);
	}
}

.header { grid-area: header; }
.btn-reg { grid-area: btn-reg; }
.btn-tkt { grid-area: btn-tkt; }
.status { grid-area: status; }
.activity { grid-area: activity; }
.scale { grid-area: scale; }
.cam1 { grid-area: cam1; }
.cam2 { grid-area: cam2; }
.cam3 { grid-area: cam3; }
.cam4 { grid-area: cam4; }
.cam5 { grid-area: cam5; }
.guide { grid-area: guide; }
.btn-cell { 
	grid-area: button;
	justify-self: end;
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.screen h1 {
	font-size: 2rem;
	margin-bottom: var(--spacing-lg);
	color: var(--text-secondary);
}

.screen h2 {
	font-size: 1.5rem;
	margin-bottom: var(--spacing-md);
	color: var(--text-secondary);
}

.screen h3 {
	font-size: 1.25rem;
	margin-bottom: var(--spacing-sm);
	color: var(--text-secondary);
}

/* Responsive design */
@media (max-width: 768px) {
	.main-content {
		padding: var(--spacing-md);
	}

	.screen {
		padding: var(--spacing-md);
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	
}

/* Print styles */
@media print {
	.wizard-actions,
	.btn {
		display: none !important;
	}

	.screen {
		box-shadow: none;
		background: white;
		padding: 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,qEAAqE;CACrE,wBAAwB;CACxB,wBAAwB;CACxB,0BAA0B;CAC1B,wBAAwB;CACxB,wBAAwB;CACxB,wBAAwB;CACxB,uBAAuB;;CAEvB,sBAAsB;CACtB,uCAAuC;CACvC,wCAAwC;CACxC,mCAAmC;CACnC,gCAAgC;;CAEhC,gBAAgB;CAChB,oBAAoB;CACpB,yBAAyB;CACzB,qBAAqB;CACrB,qBAAqB;;CAErB,kBAAkB;CAClB,uBAAuB;CACvB,uBAAuB;;CAEvB,YAAY;CACZ,qBAAqB;CACrB,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;;CAEnB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;;CAEnB,YAAY;CACZ,0CAA0C;CAC1C,0CAA0C;CAC1C,0CAA0C;CAC1C,kDAAkD;;CAElD,gBAAgB;CAChB,gCAAgC;CAChC,gCAAgC;AACjC;;AAEA;CACC,8EAA8E;CAC9E,mCAAmC;CACnC,iBAAiB;CACjB,0BAA0B;CAC1B,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;;CAElC,mBAAmB;CACnB;;;0BAGyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,OAAO;CACP,0BAA0B;CAC1B,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;CAC7B,2BAA2B;CAC3B,+BAA+B;CAC/B,0BAA0B;CAC1B,4BAA4B;CAC5B,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,sBAAsB;;CAEtB,aAAa;CACb;;;;;;+BAM8B;CAC9B,iDAAiD;CACjD,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,sBAAsB;;CAEtB,aAAa;CACb;;;;;+BAK8B;CAC9B,qCAAqC;CACrC,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,sBAAsB;;CAEtB,aAAa;CACb;;;;;+BAK8B;CAC9B,qCAAqC;CACrC,qCAAqC;AACtC;;AAEA;;;;;;;;;;GAUG;;AAEH;CACC;EACC;;;;;;;gBAOc;EACd,0DAA0D;EAC1D,qCAAqC;CACtC;AACD;;AAEA,UAAU,iBAAiB,EAAE;AAC7B,WAAW,kBAAkB,EAAE;AAC/B,WAAW,kBAAkB,EAAE;AAC/B,UAAU,iBAAiB,EAAE;AAC7B,YAAY,mBAAmB,EAAE;AACjC,SAAS,gBAAgB,EAAE;AAC3B,QAAQ,eAAe,EAAE;AACzB,QAAQ,eAAe,EAAE;AACzB,QAAQ,eAAe,EAAE;AACzB,QAAQ,eAAe,EAAE;AACzB,QAAQ,eAAe,EAAE;AACzB,SAAS,gBAAgB,EAAE;AAC3B;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC;EACC,UAAU;EACV,2BAA2B;CAC5B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;CACjB,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA,sBAAsB;AACtB;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;;AAGD;;AAEA,iBAAiB;AACjB;CACC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;CACX;AACD","sourcesContent":["/* Global styles and CSS reset */\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n:root {\n\t/* Color palette */\n\t--primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n\t--primary-color: #667eea;\n\t--primary-hover: #5a67d8;\n\t--secondary-color: #4a5568;\n\t--success-color: #48bb78;\n\t--success-hover: #38a169;\n\t--warning-color: #f6e05e;\n\t--danger-color: #dc3545;\n\n\t/* Background colors */\n\t--bg-primary: rgba(255, 255, 255, 0.95);\n\t--bg-secondary: rgba(255, 255, 255, 0.8);\n\t--bg-card: rgba(255, 255, 255, 0.8);\n\t--bg-overlay: rgba(0, 0, 0, 0.7);\n\n\t/* Text colors */\n\t--text-primary: #333;\n\t--text-secondary: #4a5568;\n\t--text-muted: #718096;\n\t--text-light: #a0aec0;\n\n\t/* Border colors */\n\t--border-light: #e2e8f0;\n\t--border-focus: #667eea;\n\n\t/* Spacing */\n\t--spacing-xs: 0.25rem;\n\t--spacing-sm: 0.5rem;\n\t--spacing-md: 1rem;\n\t--spacing-lg: 1.5rem;\n\t--spacing-xl: 2rem;\n\t--spacing-xxl: 3rem;\n\n\t/* Border radius */\n\t--radius-sm: 4px;\n\t--radius-md: 8px;\n\t--radius-lg: 12px;\n\t--radius-xl: 16px;\n\t--radius-pill: 20px;\n\n\t/* Shadows */\n\t--shadow-sm: 0 2px 20px rgba(0, 0, 0, 0.1);\n\t--shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n\t--shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.1);\n\t--shadow-focus: 0 0 0 3px rgba(102, 126, 234, 0.1);\n\n\t/* Transitions */\n\t--transition-fast: all 0.2s ease;\n\t--transition-slow: all 0.3s ease;\n}\n\nbody {\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\tbackground: var(--primary-gradient);\n\tmin-height: 100vh;\n\tcolor: var(--text-primary);\n\tline-height: 1.6;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\n\t/* height: 100vh; */\n\t/* display: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbox-sizing: border-box; */\n}\n\n.app {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.main-content {\n\tflex: 1;\n\tpadding: var(--spacing-xl);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.screen {\n\tbackground: var(--bg-primary);\n\tbackdrop-filter: blur(10px);\n\tborder-radius: var(--radius-xl);\n\tpadding: var(--spacing-xl);\n\tbox-shadow: var(--shadow-lg);\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tanimation: slideIn 0.3s ease-out;\n}\n\n.screen.home {\n\twidth: 100%;\n\theight: 100%;\n\tgap: 2rem;\n\tbox-sizing: border-box;\n\n\tdisplay: grid;\n\tgrid-template-areas:\n\t\t\"header  header  header  header\"\n\t\t\"btn-reg btn-tkt status activity\"\n\t\t\"scale   scale   cam2   cam3\"\n\t\t\"cam1    cam1    cam2   cam3\"\n\t\t\"cam1    cam1    cam4   cam5\"\n\t\t\"cam1    cam1    cam4   cam5\";\n\tgrid-template-rows: 120px 220px 150px 1fr 1fr 1fr;\n\tgrid-template-columns: repeat(4, 1fr);\n}\n\n.ticket-screen-capture {\n\twidth: 100%;\n\theight: 100%;\n\tgap: 2rem;\n\tbox-sizing: border-box;\n\n\tdisplay: grid;\n\tgrid-template-areas:\n\t\t\"scale   scale   cam2   cam3\"\n\t\t\"cam1    cam1    cam2   cam3\"\n\t\t\"cam1    cam1    cam4   cam5\"\n\t\t\"cam1    cam1    cam4   cam5\"\n\t\t\"guide\t guide\t button\tbutton\";\n\tgrid-template-rows: 150px 1fr 1fr 1fr;\n\tgrid-template-columns: repeat(4, 1fr);\n}\n\n.register-screen {\n\twidth: 100%;\n\theight: 100%;\n\tgap: 2rem;\n\tbox-sizing: border-box;\n\n\tdisplay: grid;\n\tgrid-template-areas:\n\t\t\"scale   scale   cam2   cam3\"\n\t\t\"cam1    cam1    cam2   cam3\"\n\t\t\"cam1    cam1    cam4   cam5\"\n\t\t\"cam1    cam1    cam4   cam5\"\n\t\t\"guide\t guide\t button\tbutton\";\n\tgrid-template-rows: 150px 1fr 1fr 1fr;\n\tgrid-template-columns: repeat(4, 1fr);\n}\n\n/* @media (max-width: 1800px) {\n\t.screen {\n\t\tgrid-template-areas:\n\t\t\"header  header  header  header\"\n\t\t\"btn-reg btn-tkt status activity\"\n\t\t\"scale   scale   cam2   cam2\"\n\t\t\"cam1    cam1    cam2   cam3\"\n\t\t\"cam1    cam1    cam4   cam5\";\n\t\tgrid-template-rows: 120px 220px 150px auto auto;\n\t}\n} */\n\n@media (max-width: 1200px) {\n\t.screen.home {\n\t\tgrid-template-areas:\n\t\t\"header  header\"\n\t\t\"btn-reg btn-tkt\"\n\t\t\"status activity\"\n\t\t\"scale   scale\"\n\t\t\"cam1    cam1\"\n\t\t\"cam2    cam3\"\n\t\t\"cam4    cam5\";\n\t\tgrid-template-rows: 120px 220px 180px 140px auto auto auto;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n.header { grid-area: header; }\n.btn-reg { grid-area: btn-reg; }\n.btn-tkt { grid-area: btn-tkt; }\n.status { grid-area: status; }\n.activity { grid-area: activity; }\n.scale { grid-area: scale; }\n.cam1 { grid-area: cam1; }\n.cam2 { grid-area: cam2; }\n.cam3 { grid-area: cam3; }\n.cam4 { grid-area: cam4; }\n.cam5 { grid-area: cam5; }\n.guide { grid-area: guide; }\n.btn-cell { \n\tgrid-area: button;\n\tjustify-self: end;\n}\n\n@keyframes slideIn {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(20px);\n\t}\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n@keyframes spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.screen h1 {\n\tfont-size: 2rem;\n\tmargin-bottom: var(--spacing-lg);\n\tcolor: var(--text-secondary);\n}\n\n.screen h2 {\n\tfont-size: 1.5rem;\n\tmargin-bottom: var(--spacing-md);\n\tcolor: var(--text-secondary);\n}\n\n.screen h3 {\n\tfont-size: 1.25rem;\n\tmargin-bottom: var(--spacing-sm);\n\tcolor: var(--text-secondary);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n\t.main-content {\n\t\tpadding: var(--spacing-md);\n\t}\n\n\t.screen {\n\t\tpadding: var(--spacing-md);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t}\n\n\t\n}\n\n/* Print styles */\n@media print {\n\t.wizard-actions,\n\t.btn {\n\t\tdisplay: none !important;\n\t}\n\n\t.screen {\n\t\tbox-shadow: none;\n\t\tbackground: white;\n\t\tpadding: 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
